import { Component, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { svgIcons } from './partials/svg-icons';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './partials/services/auth.service';
import { AccountRedirectListenerService } from './partials/services/account-redirect-listener.service';
import { SUPPORTED_LANGUAGES } from './partials/variables';
import { DialogService } from './partials/services/dialog.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly _translationService: TranslateService = inject(TranslateService);
  private readonly _authService: AuthService = inject(AuthService);
  private readonly _accountRedirectListenerService: AccountRedirectListenerService = inject(AccountRedirectListenerService);
  private readonly _dialogService = inject(DialogService);
  private readonly router: Router = inject(Router);

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
  ) {
    this._registerIcons(svgIcons);
    this._initTranslate();
  }

  private _initTranslate(): void {
    this._translationService.addLangs(SUPPORTED_LANGUAGES);

    effect(() => {
      const accountDto = this._authService.accountDto();
      if (accountDto) {
        const { user: { locale } } = accountDto;

        let setLang = locale;
        const siteLang: string | null = localStorage.getItem('siteLang');
        siteLang && (setLang = siteLang);

        if (setLang !== this._translationService.currentLang) {
          this._translationService.use(SUPPORTED_LANGUAGES.includes(setLang) ? setLang : 'en');
        }
      }
    });
  }

  private _initSubscriptionExpiredDialog(): void {
    const accountDto = this._authService.accountDto();
    if (!accountDto) {
      return;
    }

    if (accountDto?.userPlan.userPlanType === 'BASIC') {
      let lastUserPlan = false;
      switch (accountDto?.accountType) {
        case 'PERSONAL':
          if (accountDto?.lastExpiredUserPlan) {
            lastUserPlan = accountDto?.paidFeatureLocked;
          }
          break;
        case 'CORPORATE':
          if (accountDto?.companyDto?.lastExpiredUserPlan) {
            lastUserPlan = accountDto?.companyDto?.paidFeatureLocked;
          }
          break;
      }
      if (lastUserPlan) {
        this._openSubscriptionExpiredDialog();
      }
    }
  }

  private _openSubscriptionExpiredDialog(): void {
    this._dialogService.openSubscriptionExpired();
  }

  private _registerIcons(icons: Array<string>): void {
    icons.forEach((icon: string) => {
      this._iconRegistry.addSvgIcon(
        icon,
        this._sanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${ icon }.svg`
        )
      );
    });
  }
}
